import { HomeStore } from "./homeStore";
import { ServiceStore } from "./serviceStore";
import { UserStore } from "./userStore";
import { SignalRStore } from "./signalRStore";


export interface IRootStore {
  user: UserStore;
  home : HomeStore;
  service: ServiceStore;
  signalR: SignalRStore;
}

export class RootStore implements IRootStore {
    user: UserStore;

    home : HomeStore;

    service : ServiceStore;

    signalR: SignalRStore;

  constructor() {
    this.user = new UserStore();
    this.home = new HomeStore();
    this.service = new ServiceStore();
    this.signalR = new SignalRStore();
  }
}